import { post, get, downloadBlob } from './client';
import { makeGrowerPath } from './utils';

export function runNProtectant(growerId, aaids, params) {
  return post(makeGrowerPath(`/n-protectant/run`), {
    prodUtilized: params.product,
    prodTime: params.timing,
    baseRate: params.baseRate,
    minRate: params.minRate,
    npRateIncrement: params.increment,
    aaids,
  }).then((response) => response.map((job, i) => ({ aaid: aaids[i], job })));
}

export function getNProtectantForGrower(growerId) {
  return get(`/n-protectant/by-grower/${growerId}`);
}

export function getNProtectantStats(aaId) {
  return get(makeGrowerPath(`/n-protectant/stats/${aaId}`));
}

export function getNProtectantStatsPreview(aaId, adjustments) {
  return post(
    makeGrowerPath(`/n-protectant/stats/${aaId}/preview`),
    adjustments,
  );
}

export function getNProtectantGroupAdjustments(aaid, prodTime, prodUtilized) {
  return get(
    makeGrowerPath(
      `/n-protectant/group-adjustments/${aaid}?prodTime=${prodTime}&prodUtilized=${prodUtilized}`,
    ),
  );
}

export function setNProtectantFullFieldAdjustment(
  aaId,
  prodTime,
  prodUtilized,
  adjustment,
) {
  return post(
    makeGrowerPath(
      `/n-protectant/full-field-adjustment/${aaId}?prodTime=${prodTime}&prodUtilized=${prodUtilized}`,
    ),
    { adjustment },
  );
}

export function setNProtectantGroupAdjustments(
  aaId,
  prodTime,
  prodUtilized,
  groupAdjustments,
) {
  return post(
    makeGrowerPath(
      `/n-protectant/group-adjustments/${aaId}?prodTime=${prodTime}&prodUtilized=${prodUtilized}`,
    ),
    groupAdjustments,
  );
}

export function getNProtectantFullFieldAdjustment(
  aaid,
  prodTime,
  prodUtilized,
) {
  return get(
    makeGrowerPath(
      `/n-protectant/full-field-adjustment/${aaid}?prodTime=${prodTime}&prodUtilized=${prodUtilized}`,
    ),
  );
}

export function downloadNProtectantShapefile(growerId, aaids, timing, product) {
  return downloadBlob(`/nprotectant/${growerId}/shapefile/${timing}`, aaids, {
    product,
  });
}

export function downloadNProtectantPdfs(growerId, aaids, timing, product) {
  return downloadBlob(`/nprotectant/${growerId}/pdf/${timing}`, aaids, {
    product,
  });
}
